(() => {
  const BUBBLE_SELECTOR = '.main-menu-cart-bubble .cart-count-bubble';

  const root =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  let queued = false;

  function setCount(count) {
    document.querySelectorAll(BUBBLE_SELECTOR).forEach((bubble) => {
      bubble.classList.toggle('hidden', count === 0);

      const num = bubble.querySelector('[aria-hidden="true"]');
      if (num) num.textContent = count < 100 ? String(count) : '99+';

      const sr = bubble.querySelector('.visually-hidden');
      if (sr) sr.textContent = `${count} item${count === 1 ? '' : 's'} in cart`;
    });
  }

  async function refresh() {
    try {
      const res = await fetch(`${root}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      const cart = await res.json();
      setCount(Number(cart?.item_count || 0));
    } catch (e) {
      // silently ignore
    }
  }

  // Debounce multiple rapid calls (qty buttons etc.)
  function refreshSoon() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      refresh();
    });
  }

  // 1) Hook fetch() for cart endpoints
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await _fetch.apply(this, args);

    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      if (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear')
      ) {
        // Only refresh if request succeeded
        if (res && res.ok) refreshSoon();
      }
    } catch (_) {}

    return res;
  };

  // 2) Hook XHR as well (some themes still use it)
  const _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__isCartCall =
      typeof url === 'string' &&
      (url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear'));

    this.addEventListener('load', () => {
      if (this.__isCartCall && this.status >= 200 && this.status < 300) {
        refreshSoon();
      }
    });

    return _open.call(this, method, url, ...rest);
  };

  // 3) Initial sync on load
  document.addEventListener('DOMContentLoaded', refresh);
})();
